import React from 'react';
import { Text, Skeleton } from '@/components/ui';

interface MimeTypeCellProps {
  value?: unknown;
  mimeType?: string;
  showGroup?: boolean; // Show group (e.g., "image/*") instead of full type
  render?: () => React.ReactNode;
}

function MimeTypeCell({
  value,
  mimeType,
  showGroup = false,
  render,
}: MimeTypeCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  // Extract mimeType from value if mimeType prop is not provided
  const displayMimeType = mimeType || (value as string) || '';

  if (!displayMimeType) {
    return (
      <Text size="2" color="gray">
        —
      </Text>
    );
  }

  let displayValue: string;

  if (showGroup) {
    // Extract group (e.g., "image" from "image/png")
    const group = displayMimeType.split('/')[0];
    displayValue = group ? `${group}/*` : displayMimeType;
  } else {
    displayValue = displayMimeType;
  }

  return (
    <Text size="2" className="data-cell__mime-type">
      {displayValue}
    </Text>
  );
}

export function MimeTypeCellSkeleton() {
  return (
    <Skeleton style={{ width: '120px', height: '16px', borderRadius: '4px' }} />
  );
}

export default MimeTypeCell;

